import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import {
  Activity,
  ActivityModel,
  PaymentActivityModel,
  PaymentActivity,
  PaymentMethods
} from '../../../../../models/activities';
import { FormGroup } from '@angular/forms';
import { WorkflowContextService, Utilities } from '../../../../../services';
import { ReceiptButtonComponent } from '../payment-activity-input/receipt-button-component';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-payment-activity-view',
  templateUrl: './payment-activity-view.component.html',
  styleUrls: ['./payment-activity-view.component.css'],
  standalone: false
})
export class PaymentActivityViewComponent extends ActivityView
  implements OnInit {
  templateForPermitForm: boolean = false;
  activity: PaymentActivity;
  PaymentMethods = PaymentMethods;
  apiBase = Utilities.getRootURL();
  data: any[] = [];

  constructor(public layoutService: LayoutService, context : WorkflowContextService ) {
    super();

   layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
  }

  ngOnInit() {
    this.data = this.activity.model.payments.map(pmt => ({
      ...pmt,
      confirmationNumber: pmt.confirmationData?.confirmationNumber,
      confirmedOn: new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      }).format(new Date(pmt.confirmedOn)),
      requestedAmount: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(pmt.requestedAmount)
    }));
  }

  toMethodString(value: PaymentMethods): string {
    return PaymentMethods[value].toString();
  }

  toCurrency(value: string) {
    return Utilities.formatCurrency(value);
  }

  paymentTableColumns = [
    {
      key: 'paymentMethod',
      label: 'Payment Method',
      headerType: 'text',
      cellType: 'text'
    },
    {
      key: 'confirmedOn',
      label: 'Paid On',
      headerType: 'text',
      cellType: 'text'
    },
    {
      key: 'requestedAmount',
      label: 'Amount',
      headerType: 'text',
      cellType: 'text',
      width: '100px'
    },
    {
      key: 'confirmationNumber',
      label: 'Confirmation Number',
      headerType: 'text',
      cellType: 'text'
    },
    {
      key: 'actions',
      label: '',
      headerType: 'text',
      cellType: 'component',
      component: ReceiptButtonComponent,

      componentInputs: (row: any) => ({
        pmtId: row.id,
        apiBase: this.apiBase
      })
    }
  ];

  // get paymentTableData() {
  //   if (!this.activity.model.payments) return [];
  //   return this.activity.model.payments.map(pmt => ({
  //     ...pmt,
  //     confirmationNumber: pmt.confirmationData?.confirmationNumber,
  //     confirmedOn: new Intl.DateTimeFormat('en-US', {
  //       month: 'long', day: 'numeric', year: 'numeric',
  //       hour: 'numeric', minute: 'numeric', hour12: true
  //     }).format(new Date(pmt.confirmedOn)),
  //     requestedAmount: new Intl.NumberFormat('en-US', {
  //       style: 'currency', currency: 'USD'
  //     }).format(pmt.requestedAmount)
  //   }));
  // }
}
